import "@hotwired/turbo-rails"
import "./controllers"

// Flowbite's data-attribute components (dropdown, etc.) auto-init on
// DOMContentLoaded, which Turbo visits don't fire — re-init on each load.
import { initFlowbite } from "flowbite"
document.addEventListener("turbo:load", () => initFlowbite())